// test504
(504 && 0);
